import React from 'react';
import Button from '../../../components/ui/Button';

const QuickPrompts = ({ onSelectPrompt, sessionType }) => {
  const promptsByType = {
    general: [
      'How do I start my fitness journey?',
      'What is the best time to workout?',
      'How much water should I drink daily?'
    ],
    workout_plan: [
      'Create a beginner full-body workout plan',
      'I want to build muscle, what exercises should I do?',
      'Design a 4-day split routine for me'
    ],
    nutrition_advice: [
      'What should I eat before a workout?',
      'How do I calculate my daily calorie needs?',
      'Best foods for muscle recovery'
    ],
    form_check: [
      'How do I perform a proper squat?',
      'What is correct deadlift form?',
      'Tips for better bench press technique'
    ],
    motivation: [
      'I am feeling unmotivated, help me',
      'How do I stay consistent with workouts?',
      'I hit a plateau, what should I do?'
    ]
  };

  const prompts = promptsByType?.[sessionType] || promptsByType?.general;

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-muted-foreground mb-3">Quick prompts:</p>
      <div className="flex flex-col gap-2">
        {prompts?.map((prompt, index) => (
          <Button
            key={index}
            variant="outline"
            size="sm"
            onClick={() => onSelectPrompt(prompt)}
            className="text-left justify-start h-auto py-3 px-4"
          >
            {prompt}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickPrompts;
